import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";

const { Option } = Select;

// When `options` is supplied the caller owns the list (e.g. options derived from
// the rows actually shown in a table); the component then skips its own fetch.
const CategorySelect = ({ brandId, segmentId, value, onChange, disabled = false, multiple = false, shouldFetch = false, showAll = false, options, optionsLoading = false }) => {

  const isControlledList = Array.isArray(options);

  const { request } = useRequest();
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    setLoading(true);

    let url = apiPath.commonCategory;
    const params = [];
    if (brandId) params.push(`brand_id=${brandId}`);
    if (segmentId) params.push(`segment_id=${segmentId}`);
    if (params.length) url += `?${params.join('&')}`;

    request({
      url,
      method: "GET",
      onSuccess: (res) => {
        const categories = res?.data?.data || [];
        setCategoryList(categories);
        setLoading(false);
        if ((brandId || segmentId) && value && !categories.some(c => c._id === value)) {
          onChange?.(undefined);
        }
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(
          err?.response?.data?.message || "Failed to load categories",
          Severty.ERROR
        );
      },
    });
  };

  useEffect(() => {
    if (isControlledList) return;
    fetchCategories();
  }, [brandId, segmentId, isControlledList]);

  const list = isControlledList ? options : categoryList;
  const isLoading = isControlledList ? optionsLoading : loading;

  return (
    <Spin spinning={isLoading} tip="Loading categories..." size="small">
      <Select
        mode={multiple ? "multiple" : undefined}
        showSearch
        allowClear
        placeholder="Select category"
        optionFilterProp="children"
        value={value}
        onChange={onChange}
        disabled={disabled}
        loading={isLoading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={{ height: 40 }}
        maxTagCount={multiple ? "responsive" : undefined}
      >
        {showAll && multiple && (
          <Option key="all" value="all">
            <span className="text-blue-500 font-medium">Select All</span>
          </Option>
        )}
        {list?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default CategorySelect;
